import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-lottery',
  templateUrl: './new-lottery.component.html',
  styleUrls: ['./new-lottery.component.scss'],
})
export class NewLotteryComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
